import { render } from "./AdicionarQuestaoSelecao.vue?vue&type=template&id=8e55e8b2&ts=true"
import script from "./AdicionarQuestaoSelecao.vue?vue&type=script&lang=ts"
export * from "./AdicionarQuestaoSelecao.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__